import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { OrderingDirections } from 'apollo-angular/graphql-types';
import { DashboardTileColumn } from 'src/app/pages/dashboard/models/tile.model';
import { ReportParameterComponent } from '../../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../../report-parameter-list/report-parameter.config';

@Component({
   selector: 'ndt-column-sort-report-parameter',
   templateUrl: './column-sort-report.parameter.component.html',
   styleUrls: ['./column-sort-report.parameter.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: ColumnSortReportParameterComponent,
         multi: true,
      },
   ],
   standalone: false,
})
export class ColumnSortReportParameterComponent implements OnDestroy, ReportParameterComponent {
   config: ReportParameterConfig;

   private _form: UntypedFormGroup;

   readonly directions = Object.values(OrderingDirections).filter(
      (direction) => direction !== OrderingDirections.NotSet
   );

   columns: DashboardTileColumn[] = [];

   selectedColumn?: DashboardTileColumn;
   selectedDirection: OrderingDirections = OrderingDirections.Asc;

   set form(form: UntypedFormGroup) {
      this._form = form;

      if (this.config.type === 'columnSort') {
         this.columns = this.config.columnNames;
      }

      this.initializeValue(this.form.value?.value);
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label(): string {
      return this.config?.label || '';
   }

   ngOnDestroy(): void {}

   constructor(private store: Store) {}

   private initializeValue(value?: string): void {
      if (!value) {
         this.selectedColumn = this.columns[0];
         this.selectedDirection = OrderingDirections.Asc;
         this.updateValue();
         return;
      }

      const [columnName, direction] = value.split(':');

      this.selectedColumn = this.columns.find((c) => c.name === columnName) ?? this.columns[0];

      this.selectedDirection = (direction as OrderingDirections) ?? OrderingDirections.Asc;
   }

   onColumnChanged(column: DashboardTileColumn): void {
      this.selectedColumn = column;
      this.updateValue();
   }

   onDirectionChanged(direction: OrderingDirections): void {
      this.selectedDirection = direction;
      this.updateValue();
   }

   private updateValue(): void {
      this.form.patchValue({
         value: `${this.selectedColumn?.name}:${this.selectedDirection}`,
      });
   }
}
